import { useQuery } from '@vue/apollo-composable'
import { ComputedRef } from 'vue'
import { graphql } from '@/gql'
import { PER_PAGE_MAXIMUM } from '@/utils/constants'

export const useQueryTimesheet = (timesheetId: ComputedRef<string | null>) =>
  useQuery(
    graphql(/* GraphQL */ `
      query Timesheet($timesheetId: ID!, $first: Int) {
        timesheet(id: $timesheetId) {
          ...TimesheetFormFragment
        }
      }
    `),
    () => ({
      timesheetId: timesheetId.value || '',
      first: PER_PAGE_MAXIMUM,
    }),
    () => ({
      clientId: 'publicApi',
      enabled: !!timesheetId.value,
    }),
  )
